/**
 * Created by andrey on 02.07.2020
 */

const BaseBoosterBefore = function (id) { 
    BaseBooster.call(this, id);

    this.spentEvent = cleverapps.EVENTS.SPENT.BOOSTER_BEFORE;
};

BaseBoosterBefore.prototype = Object.create(BaseBooster.prototype);
BaseBoosterBefore.prototype.constructor = BaseBoosterBefore;

BaseBoosterBefore.prototype.onUsed = function () {
    cleverapps.eventBus.trigger("taskEvent", "USE_BOOSTER_BEFORE");
    cleverapps.eventBus.trigger("use_booster", { id: this.id });
};

BaseBoosterBefore.prototype.onGiveUp = function () {
    if (cleverapps.lives && (!this.getLanternBonus() || cleverapps.config.features.includes("lantern_start"))) {
        cleverapps.boosters.add(this.id, 1);
    }
};

BaseBoosterBefore.prototype.getLanternBonus = function () {
    return typeof Lantern !== "undefined" && Lantern.GetBoosterBonus(Game.currentGame.level, this);
};

BaseBoosterBefore.prototype.logUseEvents = cleverapps.extendFunc(BaseBoosterBefore.prototype.logUseEvents, function () {
    if (!this.getLanternBonus() || cleverapps.config.features.includes("lantern_start")) {
        this._super();
    }
});

BaseBoosterBefore.prototype.execute = cleverapps.extendFunc(BaseBoosterBefore.prototype.execute, function () {
    const bonus = this.getLanternBonus();

    if (bonus && !cleverapps.config.features.includes("lantern_start")) {
        this.setAmount(this.getAmount() + 1);
    }

    this._super();
});

BaseBoosterBefore.prototype.isUpcoming = function () {
    const boosters = cleverapps.boosters.listBoostersBefore();

    for (let i = 0; i < boosters.length; i++) {
        if (!boosters[i].isAvailable()) {
            return boosters[i] === this;
        }
    }

    return false;
};